import className from 'classnames/bind';
import { Container, FormButton, PostsList, SpinnerIcon } from '@/components';
import styles from './Posts.module.scss';
import { gql, useQuery } from '@apollo/client';
import { useState } from 'react';

let cx = className.bind(styles);

const PostsQuery = gql`
	query GetPosts($categoryId: Int, $tagId: String, $first: Int, $last: Int, $after: String, $before: String) {
		posts(where: { categoryId: $categoryId, tagId: $tagId }, first: $first, last: $last, after: $after, before: $before) {
			edges {
				node {
					id
					title
					date
					uri
					featuredImage {
						node {
							id
							sourceUrl
							altText
							mediaDetails {
								width
								height
							}
						}
					}
					author {
						node {
							name
							avatar(size: 120) {
								url
							}
						}
					}
				}
			}
			pageInfo {
				hasNextPage
				hasPreviousPage
				startCursor
				endCursor
			}
		}
	}
`;

export function Posts({ categoryId, tagId, title, categories, postPerPage = 12 }) {
	const [selectedCategory, setSelectedCategory] = useState(null);
	const variables = {
		tagId: tagId?.toString(),
		categoryId: categoryId || selectedCategory,
		first: postPerPage,
		last: null,
		after: null,
		before: null,
	};

	const { data, error, loading, fetchMore } = useQuery(PostsQuery, {
		variables,
	});

	if (error) {
		return <pre>{JSON.stringify(error)}</pre>;
	}

	function selectCategory(category) {
		if (selectedCategory === category.node.databaseId) {
			setSelectedCategory(null);
		} else {
			setSelectedCategory(category.node.databaseId);
		}
	}

	return (
		<Container>
			{title && <h2 className={cx(['category-title'])}>{title}</h2>}
			{categories && (
				<div className={cx(['category-list'])}>
					{categories.map((category) => (
						<FormButton key={category.node.databaseId} className={cx(['category-btn', selectedCategory === category.node.databaseId && 'active'])} onClick={() => selectCategory(category)}>
							{category.node.name}
						</FormButton>
					))}
				</div>
			)}
			{loading ? (
				<div className={cx(['loading-posts-icon-container'])}>
					<SpinnerIcon className={cx(['loading-posts-icon'])} />
				</div>
			) : (
				<PostsList fetchMore={fetchMore} posts={data?.posts} postPerPage={postPerPage} pagination={true} articleHeadingStyle="is-style-heading-body" imageSizes="(max-width: 500px) 50vw, (max-width: 820px) 220px, (max-width: 1600px) 25vw, 340px" />
			)}
		</Container>
	);
}
